import { useEffect } from 'react';

const APP_TITLE = 'Planapus';
const TITLE_SEPARATOR = ' | ';
const BREADCRUMB_SEPARATOR = ' > ';
const MAX_TITLE_LENGTH = 60;
const ELLIPSIS = '...';

function truncateText(value: string, maxLength: number): string {
  if (maxLength <= 0) return '';
  if (value.length <= maxLength) return value;
  if (maxLength <= ELLIPSIS.length) return value.slice(0, maxLength);
  return `${value.slice(0, maxLength - ELLIPSIS.length).trimEnd()}${ELLIPSIS}`;
}

function composeTitle(section?: string, entity?: string): string {
  const cleanSection = section?.trim();
  const cleanEntity = entity?.trim();

  if (!cleanSection) {
    return APP_TITLE;
  }

  const suffix = `${TITLE_SEPARATOR}${APP_TITLE}`;

  if (!cleanEntity) {
    return truncateText(`${cleanSection}${suffix}`, MAX_TITLE_LENGTH);
  }

  const prefix = `${cleanSection}${BREADCRUMB_SEPARATOR}`;
  const availableForEntity = MAX_TITLE_LENGTH - prefix.length - suffix.length;

  if (availableForEntity <= 0) {
    return truncateText(`${cleanSection}${suffix}`, MAX_TITLE_LENGTH);
  }

  const truncatedEntity = truncateText(cleanEntity, availableForEntity);
  return `${prefix}${truncatedEntity}${suffix}`;
}

export function useDocumentTitle(section?: string, entity?: string): void {
  useEffect(() => {
    document.title = composeTitle(section, entity);
  }, [section, entity]);
}

